import {messages} from './i18n/i18n';

export const titles = {
    settings: messages.fr.titles.settings,
    support: messages.fr.titles.support,
    dashboard: messages.fr.titles.dashboard,
    organisations: messages.fr.titles.organisations,
    network: messages.fr.titles.network,
    organisationsList: messages.fr.titles.organisationsList,
    clientList: messages.fr.titles.clientList,
    commercialList: messages.fr.titles.commercialList,
    moduleList: messages.fr.titles.moduleList,
    functionnalityList: messages.fr.titles.functionnalityList,
    domainList: messages.fr.titles.domainList,
    typePacksList: messages.fr.titles.typePacksList,
    packsList: messages.fr.titles.packsList,

    add: messages.fr.titles.add,
    update: messages.fr.titles.update,
    generalInfo: messages.fr.titles.generalInfo,

    domainListExpression: messages.fr.titles.domainListExpression,
    domainAddExpression: messages.fr.titles.domainAddExpression,
    domainEditExpression: messages.fr.titles.domainEditExpression,
    commercialListExpression: messages.fr.titles.commercialListExpression,
    commercialAddExpression: messages.fr.titles.commercialAddExpression,
    commercialEditExpression: messages.fr.titles.commercialEditExpression,
    commercialDetailExpression: messages.fr.titles.commercialDetailExpression,
    placeholderNameDomain: messages.fr.titles.placeholderNameDomain,
    placeholderUrlDomain: messages.fr.titles.placeholderUrlDomain,
    errorNameDomain: messages.fr.titles.errorNameDomain,
    errorLengthNameDomain(val = 0) {
        return messages.fr.titles.errorLengthNameDomain(val);
    },
    errorUrlDomain: messages.fr.titles.errorUrlDomain,
    errorFormatUrlDomain: messages.fr.titles.errorFormatUrlDomain,
    deleteDomainSuccesTitle: messages.fr.titles.deleteDomainSuccesTitle,
    deletePackCountryDomainSuccessTitle: messages.fr.titles.deletePackCountryDomainSuccessTitle,
    moduleListExpression: messages.fr.titles.moduleListExpression,
    moduleAddExpression: messages.fr.titles.moduleAddExpression,
    moduleEditExpression: messages.fr.titles.moduleEditExpression,
    placeholderNameModule: messages.fr.titles.placeholderNameModule,
    placeholderUrlModule: messages.fr.titles.placeholderUrlModule,
    errorNameModule: messages.fr.titles.errorNameModule,
    errorLengthNameModule(val = 0) {
        return messages.fr.titles.errorLengthNameModule(val);
    },
    errorUrlModule: messages.fr.titles.errorUrlModule,
    errorFormatUrlModule: messages.fr.titles.errorFormatUrlModule,
    deleteModuleSuccesTitle: messages.fr.titles.deleteModuleSuccesTitle,
    deleteModuleErrorTitle: messages.fr.titles.deleteModuleErrorTitle,
    deleteDomainErrorTitle: messages.fr.titles.deleteDomainErrorTitle,
    deleteFunctionalityErrorTitle: messages.fr.titles.deleteFunctionalityErrorTitle,
    deleteTypePackErrorTitle: messages.fr.titles.deleteTypePackErrorTitle,
    deleteFunctionalitySuccesTitle: messages.fr.titles.deleteFunctionalitySuccesTitle,
    configureTypePackSuccessTitle: messages.fr.titles.configureTypePackSuccessTitle,

    typePackListExpression: messages.fr.titles.typePackListExpression,
    typePackAddExpression: messages.fr.titles.typePackAddExpression,
    typePackEditExpression: messages.fr.titles.typePackEditExpression,
    placeholderNameTypePack: messages.fr.titles.placeholderNameTypePack,
    placeholderOrderTypePack: messages.fr.titles.placeholderOrderTypePack,
    errorNameTypePack: messages.fr.titles.errorNameTypePack,
    errorLengthNameTypePack(val = 0) {
        return messages.fr.titles.errorLengthNameTypePack(val);
    },
    errorFormatOrderTypePack: messages.fr.titles.errorFormatOrderTypePack,
    errorOrderTypePack: messages.fr.titles.errorOrderTypePack,
    deleteTypePackSuccesTitle: messages.fr.titles.deleteTypePackSuccesTitle,

    functionalityListExpression: messages.fr.titles.functionalityListExpression,
    functionalityAddExpression: messages.fr.titles.functionalityAddExpression,
    placeholderNameFunctionality: messages.fr.titles.placeholderNameFunctionality,
    placeholderModuleFunctionality: messages.fr.titles.placeholderModuleFunctionality,
    placeholderDetailFunctionality: messages.fr.titles.placeholderDetailFunctionality,
    functionalityEditExpression: messages.fr.titles.functionalityEditExpression,
    errorNameFunctionality: messages.fr.titles.errorNameFunctionality,
    errorModuleFunctionality: messages.fr.titles.errorModuleFunctionality,
    placeholderDetailsFunctionality: messages.fr.titles.placeholderDetailsFunctionality,
    errorDetailsFunctionality: messages.fr.titles.errorDetailsFunctionality,
    errorLengthNameFunctionality(val = 0) {
        return messages.fr.titles.errorLengthNameFunctionality(val);
    },
    organisationListExpression: messages.fr.titles.organisationListExpression,
    organisationAddExpression: messages.fr.titles.organisationAddExpression,
    organisationEditExpression: messages.fr.titles.organisationEditExpression,
    payment: messages.fr.titles.payment,
    paymentAdd: messages.fr.titles.paymentAdd,
    clientInfo: messages.fr.titles.clientInfo,
    organisationInfo: messages.fr.titles.organisationInfo,
    organisationName: messages.fr.titles.organisationName,
    organisationAddress: messages.fr.titles.organisationAddress,
    timeZone: messages.fr.titles.timeZone,
    organisationTva: messages.fr.titles.organisationTva,
    taxRegistrationNumber: messages.fr.titles.taxRegistrationNumber,
    cnssAffiliation: messages.fr.titles.cnssAffiliation,
    commercialRegister: messages.fr.titles.commercialRegister,
    WebSite: messages.fr.titles.WebSite,
    activityArea: messages.fr.titles.activityArea,
    packsInfo: messages.fr.titles.packsInfo,
    typePack: messages.fr.titles.typePack,
    pricePack: messages.fr.titles.pricePack,
    subscriptionPeriod: messages.fr.titles.subscriptionPeriod,
    trialPeriod: messages.fr.titles.trialPeriod,
    numberOfHoursOfSupport: messages.fr.titles.numberOfHoursOfSupport,
    numberOfUsers: messages.fr.titles.numberOfUsers,
    fieldIsRequired: messages.fr.titles.fieldIsRequired,
    invalidEmail: messages.fr.titles.invalidEmail,
    errorLengthName(val = 0) {
        return messages.fr.titles.errorLengthName(val);
    },
    errorLengthNameMax(val = 0) {
        return messages.fr.titles.errorLengthNameMax(val);
    },
    errorFormatUrl: messages.fr.titles.errorFormatUrl,
    errorFormatNumeric: messages.fr.titles.errorFormatNumeric,
    firstNameCommercial: messages.fr.titles.firstNameCommercial,
    lastNameCommercial: messages.fr.titles.lastNameCommercial,
    adresseEmailCommercial: messages.fr.titles.adresseEmailCommercial,
    societyNameCommercial: messages.fr.titles.societyNameCommercial,
    placeholderPays: messages.fr.titles.placeholderPays,
    statusCommercial: messages.fr.titles.statusCommercial,
    deleteCommercialSuccesTitle: messages.fr.titles.deleteCommercialSuccesTitle,

    firstName: messages.fr.titles.firstName,
    lastName: messages.fr.titles.lastName,
    phone: messages.fr.titles.phone,
    country: messages.fr.titles.country,
    currency: messages.fr.titles.currency,
    language: messages.fr.titles.language,
    choiceClient: messages.fr.titles.choiceClient,
    generatePromoCode: messages.fr.titles.generatePromoCode,
    next: messages.fr.titles.next,
    isFree: messages.fr.titles.isFree,
    isUnlimited: messages.fr.titles.isUnlimited,
    previous: messages.fr.titles.previous,

    placeholderDomainPack: messages.fr.titles.placeholderDomainPack,
    placeholderCountryPack: messages.fr.titles.placeholderCountryPack,

    packConfigTitle: messages.fr.titles.packConfigTitle,
    defaultPack: messages.fr.titles.defaultPack,

    hasValue: messages.fr.titles.hasValue,
    dontHaveValue: messages.fr.titles.dontHaveValue,
    FunctionalyInfo: messages.fr.titles.FunctionalyInfo,
    addOrganisationMessage: messages.fr.titles.addOrganisationMessage,
    addClientMessage: messages.fr.titles.addClientMessage,
    addCommercialMessage: messages.fr.titles.addCommercialMessage,
    updateClientMessage: messages.fr.titles.updateClientMessage,
    updateCommercialMessage: messages.fr.titles.updateCommercialMessage,
    updaterganisationMessage: messages.fr.titles.updaterganisationMessage,
    deleterganisationMessage: messages.fr.titles.deleterganisationMessage,
    confirmDeleteClientMessage: messages.fr.titles.confirmDeleteClientMessage,
    confirmDeleteCommercialMessage: messages.fr.titles.confirmDeleteCommercialMessage,
    confirmDeleterganisationMessage: messages.fr.titles.confirmDeleterganisationMessage,
    deleteClientSuccesTitle: messages.fr.titles.deleteClientSuccesTitle,

    Functionaly: messages.fr.titles.Functionality,
    Details: messages.fr.titles.Details,
    Value: messages.fr.titles.Value,
    Configurate: messages.fr.titles.Configurate,

    clientListExpression: messages.fr.titles.clientListExpression,
    clientAddExpression: messages.fr.titles.clientAddExpression,
    clientEditExpression: messages.fr.titles.clientEditExpression,
    clientDetailExpression: messages.fr.titles.clientDetailExpression,
    pleaseSelectCountryDomain: messages.fr.titles.pleaseSelectCountryDomain,
    cannotDeleterganisationMessage: messages.fr.titles.cannotDeleterganisationMessage,
    cannotPaySubscriptionMessage: messages.fr.titles.cannotPaySubscriptionMessage,

    errorMinValue(val = 0) {
        return messages.fr.titles.errorMinValue(val);
    },
    errorMaxValue(val = 0) {
        return messages.fr.titles.errorMaxValue(val);
    },
    profile: messages.fr.titles.profile,
    oldpassword: messages.fr.titles.oldpassword,
    newpassword: messages.fr.titles.newpassword,
    newRetypedPassword: messages.fr.titles.newRetypedPassword,
    profileUpdateExpression: messages.fr.titles.profileUpdateExpression,
    firstNameAdmin: messages.fr.titles.firstNameAdmin,
    lastNameAdmin: messages.fr.titles.lastNameAdmin,
    pleaseTapYourPassword: messages.fr.titles.pleaseTapYourPassword,
    confirmation: messages.fr.titles.confirmation,
    toConfirm: messages.fr.titles.toConfirm,
    toCancel: messages.fr.titles.toCancel,
    passwordInvalid: messages.fr.titles.passwordInvalid,
    invalidPasswordMessage: messages.fr.titles.invalidPasswordMessage,
    successProfilMessage: messages.fr.titles.successProfilMessage,
    passwordNotSame: messages.fr.titles.passwordNotSame,
    decimal: messages.fr.titles.decimal,
    checkDecimalNumber: messages.fr.titles.checkDecimalNumber,
    updatePassword: messages.fr.titles.updatePassword,
    confirmationMail: messages.fr.titles.confirmationMail,
    updatePackCountryDomain: messages.fr.titles.updatePackCountryDomain,

    personalInfo: messages.fr.titles.personalInfo,
    activateCompte: messages.fr.titles.activateCompte,
    examplePhoneNumber: messages.fr.titles.examplePhoneNumber,
    emailExist: messages.fr.titles.emailExist,
    recoveryCode: messages.fr.titles.recoveryCode,
    sendEmailrecoveryCode: messages.fr.titles.sendEmailrecoveryCode,
    alreadyHaveACode: messages.fr.titles.alreadyHaveACode,
    send: messages.fr.titles.send,
    signInHere: messages.fr.titles.signInHere,
    rememberIt: messages.fr.titles.rememberIt,
    resetPassword: messages.fr.titles.resetPassword,
    recoveryCodeAndResetPassword: messages.fr.titles.recoveryCodeAndResetPassword,
    errorLengthCode(val = 0) {
        return messages.fr.titles.errorLengthCode(val);
    },
    codeWrong: messages.fr.titles.codeWrong,
    rememberYourPassword: messages.fr.titles.rememberYourPassword,
    enterNewPassword: messages.fr.titles.enterNewPassword,
    enterConfirmNewPassword: messages.fr.titles.enterConfirmNewPassword,
    enterRecoveryCode: messages.fr.titles.enterRecoveryCode,
    recoveryCodeHasBeenSentToYourEmail: messages.fr.titles.recoveryCodeHasBeenSentToYourEmail,
    invalidCredentials: messages.fr.titles.invalidCredentials,
    addClientErrorMessage: messages.fr.titles.addClientErrorMessage,
    emptyData: messages.fr.titles.emptyData,
    active: messages.fr.titles.active,
    light: messages.fr.titles.light,
    displayed: messages.fr.titles.displayed,
    acceptPayment: messages.fr.titles.acceptPayment,
    declinePayment: messages.fr.titles.declinePayment,
    confirmUpdateTitle: messages.fr.titles.confirmUpdateTitle,
    confirmUpdateMessage: messages.fr.titles.confirmUpdateMessage,
    unlimited: messages.fr.titles.unlimited,
    NoFreePeriod: messages.fr.titles.NoFreePeriod,
    free: messages.fr.titles.free,
    days: messages.fr.titles.days,
    testPeriod: messages.fr.titles.testPeriod,
    nbUsers: messages.fr.titles.nbUsers,
    nbSupport: messages.fr.titles.nbSupport,
    cannotDeleteClientMessage: messages.fr.titles.cannotDeleteClientMessage,
    yourPasswordHasBeenChanged: messages.fr.titles.yourPasswordHasBeenChanged,
    invalidPhoneNumber: messages.fr.titles.invalidPhoneNumber,
    invalidVerificationCode: messages.fr.titles.invalidVerificationCode,
    errorSendingVerificationCode: messages.fr.titles.errorSendingVerificationCode,
    pleaseAddCustomers: messages.fr.titles.pleaseAddCustomers,
    noCustomersToShowPleaseAddANew: messages.fr.titles.noCustomersToShowPleaseAddANew,
    checkExistLabel: messages.fr.titles.checkExistLabel,
    postalCode: messages.fr.titles.postalCode,
    city: messages.fr.titles.city,
    additionalAddress: messages.fr.titles.additionalAddress,
    numSIRET: messages.fr.titles.numSIRET,
    unpaid: messages.fr.titles.unpaid,
    paid: messages.fr.titles.paid,
    cannotAddOperationMessage: messages.fr.titles.cannotAddOperationMessage,
    successPayment: messages.fr.titles.successPayment,
    errorPayment: messages.fr.titles.errorPayment,
    cardNotSupported: messages.fr.titles.cardNotSupported,
    card3DSecure: messages.fr.titles.card3DSecure,
    cardInsufficientFunds: messages.fr.titles.cardInsufficientFunds,
    cancelPayment: messages.fr.titles.cancelPayment,
    loading: messages.fr.titles.loading,
    functionalityPack: messages.fr.titles.functionalityPack,
    noValue: messages.fr.titles.noValue,
    logs: messages.fr.titles.logs,
    organisationPack: messages.fr.titles.organisationPack,
    organisationMontant: messages.fr.titles.organisationMontant,
    organisationPaymentState: messages.fr.titles.organisationPaymentState,
    organisationStartDate: messages.fr.titles.organisationStartDate,
    organisationEndDate: messages.fr.titles.organisationEndDate,
    organisationLinkToStark: messages.fr.titles.organisationLinkToStark,
    starkInstanceInProgress: messages.fr.titles.starkInstanceInProgress,
};
